import { useTranslation } from 'react-i18next';

import { useMediaPreview, fmtTime } from './MediaPreviewContext';

/**
 * Sticky mini audio player — prototype's `.mp`/`#mp` (pp-campaign-builder-
 * prototype.html lines 296-305, `auRender()` ~811-823). Rendered only where
 * the sheet's media tab is visible (MediaList.jsx `builderRow` branch) —
 * hidden entirely (`AU.o` null) whenever nothing is loaded, exactly like
 * the prototype's `mp.hidden = !AU.o`.
 */
function MiniPlayer() {
  const { t } = useTranslation();
  const { audio } = useMediaPreview();
  if (!audio.item) return null;

  const name = audio.item.file_name || audio.item.title || audio.item.n || '';

  return (
    <div className="pp-cb-mp">
      <button type="button" className="mpb" onClick={() => audio.toggle(audio.item)} aria-label={t('buttons.play_pause')}>
        <i className={audio.playing ? 'pi pi-pause' : 'pi pi-play'} />
      </button>
      <div className="mpt">
        <div className="a">
          <span>{audio.playing ? t('addcontent.mp_playing') : t('addcontent.mp_paused')}</span>
          {name}
        </div>
        <div
          className="pbar"
          onClick={(e) => {
            const r = e.currentTarget.getBoundingClientRect();
            const frac = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
            audio.seek(frac);
          }}
        >
          <i style={{ width: audio.dur ? `${(audio.pos / audio.dur) * 100}%` : '0%' }} />
        </div>
      </div>
      <span className="mptime">{fmtTime(audio.pos)} / {fmtTime(audio.dur)}</span>
      <button type="button" className="mpx" onClick={() => audio.stop()} aria-label={t('buttons.close')}>
        <i className="pi pi-times" />
      </button>
    </div>
  );
}

export default MiniPlayer;
